import { FormPanel } from "../../../../modules/content/components/FormPanel/FormPanel";
import { StratosCommonContent } from "../../../../modules/content/components/StratosCommonContent/StratosCommonContent";
import { StratosSection } from "../../../../modules/content/components/StratosSection/StratosSection";
import type { IFormBlockProps } from "./FormBlock.props";

export const FormBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  errorMessage,
  eyebrow,
  fields,
  heading,
  parentClass,
  spacing,
  submitLabel,
  successMessage,
}: IFormBlockProps) => {
  if (!fields?.length) return null;
  return (
    <StratosSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="grid overflow-hidden rounded-[20px] bg-mist lg:grid-cols-12">
        <StratosCommonContent
          alignment={alignment}
          buttons={buttons}
          className="p-7 md:p-10 lg:col-span-5 lg:p-14"
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div className="bg-cloud-white p-7 md:p-10 lg:col-span-7 lg:p-14">
          <FormPanel
            errorMessage={errorMessage}
            fields={fields}
            submitLabel={submitLabel}
            successMessage={successMessage}
          />
        </div>
      </div>
    </StratosSection>
  );
};

FormBlock.displayName = "Block::FormBlock";
